define('components/decorators/submit-reload',[
    'jquery',
    '../util/reload-fragments'
],function( $, reload ){

    var PENDING_REQUEST = 'pendingRequest';
    var FORM_ERROR_HEADER = 'form-errors';

    $.extend(companyInfo.handlers,{

        'submit-reload': function(e){

            var button = $(this);
            var form = button.closest('form');
            var method = form.attr('method');
            var url = form.attr('action');
            var data = form.serializeArray();
            var reloadType = this.getAttribute('data-reload-type');
            var icon = button.find('.ico');
            var request = form.data(PENDING_REQUEST);

            if ( this.value ) {
                data.push({
                    name: this.name,
                    value: this.value
                });
            }

            if ( !data.length || !form.length || !validForm(form) ) {
                return;
            }

            e.preventDefault();

            if ( icon.length ) {
                var curClass = icon[0].className;
                icon[0].className = 'ico ico-spinner ico-spin' + (icon.hasClass('ico-end') ? ' ico-end': icon.hasClass('ico-single') ? ' ico-single' : '');
            }

            if ( request ) {
                request.abort();
            }

            request = $.ajax({
                url: url,
                method: method || "get",
                data: data
            }).done(function( response, status, request ){
                if ( request.getResponseHeader(FORM_ERROR_HEADER) ) {
                    // just replace the form contents, assuming the response contains only the form.
                    form.html( response );
                } else {
                    // replace reload section content.
                    var sections = reload.getSections(reloadType);
                    reload.replaceContent(response,sections);
                }
            }).always(function(){
                if ( icon.length ) {
                    icon[0].className = curClass;
                }
                form.data(PENDING_REQUEST, null);
            });

            form.data(PENDING_REQUEST, request);

        }

    });

    // Can only check if required is fulfilled.
    // Currently only checking checboxes
    function validForm( form ){
        var valid = true;
        form.find('[type=checkbox][required]').each(function(){
            valid = !valid ? false : this.checked;
        });

        return valid;
    }

});
